import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getStatistics } from '@/utils/report';
import ReportStatistics from '@/views/mainRoute/procedure/details/ReportStatistics.vue';

export const procedureReportStatisticsRoute: RouteConfig = {
  path: 'statistics',
  name: 'procedureReportStatistics',
  component: ReportStatistics,
  beforeEnter: (to, from, next) =>
    getStatistics(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.STATISTICS_CANNOT_GET }))
};
